// utils/safeLazy.js
import { lazy } from 'react';

export const safeLazy = (factory, fallbackComponent) => {
  return lazy(() =>
    factory().catch((err) => {
      // eslint-disable-next-line no-console
      console.error("Failed to load remote module:", err);
      return { default: fallbackComponent };
    })
  );
};
